<template>
  <v-card class="mx-3 my-3">
    <v-card-text class="pa-0">
      <v-data-table
        :headers="headers"
        :items="itemsPaginados"
        hide-default-footer
        disable-pagination
      >
        <template #footer>
          <data-table-pagination
            :pagina="pagina"
            :items-por-pagina="itemsPorPagina"
            :total-items="totalItemsFiltrados"
            @update:pagina="actualizarPagina"
            @update:items-por-pagina="actualizarItemsPorPagina"
          />
        </template>

        <template v-slot:top>
          <v-toolbar flat>
            <v-col class="pl-0 pt-7" sm="4" lg="3">
              <v-text-field
                v-model="search"
                placeholder="Buscar..."
                append-icon="search"
                dense
                clearable
              />
            </v-col>
          </v-toolbar>
          <v-divider />
        </template>
      </v-data-table>
    </v-card-text>
  </v-card>
</template>

<script>
import DataTablePagination from '../../../../components/Table/DataTablePagination.vue';
import { paginacionMixin } from '../../../../mixins/paginacionMixin';

export default {
  name: 'LogTable',

  components: {
    DataTablePagination,
  },

  mixins: [paginacionMixin],

  props: {
    logs: {
      type: Array,
      required: true,
    },
  },

  data() {
    return {
      headers: [
        {
          text: 'Usuario',
          value: 'NombreUser',
          sortable: false,
          align: 'center',
        },
        { text: 'Evento', value: 'Evento', sortable: false, align: 'center' },
        {
          text: 'Descripción',
          value: 'DescripcionEvento',
          sortable: false,
          align: 'center',
        },
        { text: 'Email', value: 'Email', sortable: false, align: 'center' },
        { text: 'Fecha', value: 'Fecha', sortable: false, align: 'center' },
        {
          text: 'Compañia',
          value: 'descCompania',
          sortable: false,
          align: 'center',
        },
        {
          text: 'Sucursal',
          value: 'descripcionSucursal',
          sortable: true,
          align: 'center',
        },
      ],
    };
  },

  computed: {
    datosParaPaginar() {
      return this.logs;
    },
  },
};
</script>
